module.exports = require('./helpers/bundle-url').getBundleURL('ba7Qm') + "logo-dark.eefe0b7f.svg";